import type { GraphqlErrorReason } from '@ms/yammer-data/dist/api/types';

export const userProvisioningErrors: GraphqlErrorReason[] = ['PENDING_USER', 'USER_NOT_MAPPED'];
